// A date rule's message under the field it is about (release 3.3, lib/dateRules.ts).
// The id is what the input names in aria-describedby, so a screen reader reads
// the message with the field; role="alert" announces it once when it appears.
export function DateRuleNote({ id, message }: { id: string; message: string }) {
  if (!message) return null
  return (
    <p className="field-error date-rule" id={id} role="alert">
      {message}
    </p>
  )
}

// A date WARNING under its field (release 3.3, M4): amber, not red, and never
// blocking; it says what to check. role="status" rather than "alert": it is
// news, not a refusal. The words come from lib/dateRules.ts.
export function DateWarnNote({ id, message }: { id: string; message: string }) {
  if (!message) return null
  return (
    <p className="field-warning date-rule" id={id} role="status">
      <span className="vh">Warning: </span>
      {message}
    </p>
  )
}
